import { Component, EventEmitter, Inject, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { ICompanyFilterParams } from "src/app/ui/models/domains/pbm/companies/company-filter-params";
import { LoadingService } from "src/app/ui/services/loading.service";
import { CompanyService } from "src/app/ui/services/pbm/company.service";

@Component({
  templateUrl: "./company-filter-dialog.component.html",
  styleUrls: ["./company-filter-dialog.component.scss"],
})
export class CompanyFilterDialogComponent implements OnInit {
  public applyFilterEvent: EventEmitter<Company> = new EventEmitter();
  public filter: string = "";
  public selectAllCompaniesFormControl = new UntypedFormControl(false);

  private companyList: Company[] = [];
  private selectedCompany: Company;

  constructor(
    public dialogRef: MatDialogRef<CompanyFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private companyService: CompanyService,
    private loadingService: LoadingService,
  ) {}

  async ngOnInit() {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const pagingRequest = new PagingRequest();
      pagingRequest.setStart(1);
      pagingRequest.setEnd(10);
      const filterParams: ICompanyFilterParams = {
        filterText: "",
        status: 3,
      };
      const pageableResult = await this.companyService.searchCompany(filterParams, pagingRequest);
      this.companyList = pageableResult.getItems() as Company[];
    } catch (error) {
      console.log(error);
    } finally {
      loadingRef.closeLoading();
    }
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public applyFilter(): void {
    this.applyFilterEvent.emit(this.selectedCompany);
    this.closeDialog();
  }

  public getCompanyList(): Company[] {
    return this.companyList;
  }

  public showAllCompaniesOption(): boolean {
    return !this.data?.length;
  }

  public onSelectedCompanyChange(company: Company): void {
    const matRadioButtom = document.getElementById("radio_buttom_" + company.getFiscalNumber()) as unknown as HTMLElement;
    matRadioButtom.classList.add("mat-radio-checked");

    this.selectedCompany = company;
    this.selectAllCompaniesFormControl.setValue(false);
  }

  public async onSearchCompanyFiltered(): Promise<void> {
    const loadingRef = this.loadingService.beginLoading();

    try {
      const pagingRequest = new PagingRequest();
      pagingRequest.setStart(1);
      pagingRequest.setEnd(10);
      const filterParams: ICompanyFilterParams = {
        filterText: this.filter.replace(/[./-]/g, ""),
      };
      this.companyService.searchCompany(filterParams, pagingRequest);
      const pageableResult = await this.companyService.searchCompany(filterParams, pagingRequest);
      this.companyList = pageableResult.getItems() as Company[];
      this.filter = "";
    } catch (error) {
      console.log(error);
    } finally {
      loadingRef.closeLoading();
    }
  }

  public onSelectAllCompanies(event: MatCheckboxChange) {
    if (event.checked) {
      this.uncheckSelectedCompany();
      this.selectedCompany = null;
    }
  }

  private uncheckSelectedCompany(): void {
    if (this.selectedCompany) {
      const matRadioButtom = document.getElementById("radio_buttom_" + this.selectedCompany.getFiscalNumber()) as unknown as HTMLElement;
      matRadioButtom.classList.remove("mat-radio-checked");

      const radioButtonInput = document.getElementById("radio_buttom_" + this.selectedCompany.getFiscalNumber() + "-input") as unknown as HTMLInputElement;
      radioButtonInput.checked = false;
    }
  }
}
